<template>
  <div class="clinic-state">
    <!-- Loading: skeleton -->
    <div v-if="state === 'loading'" class="clinic-state__skel" aria-busy="true">
      <div
        v-for="n in rows"
        :key="n"
        class="skel-line"
        :style="{ width: skelWidth(n), height: '16px', marginBottom: '14px' }"
      />
    </div>

    <!-- Empty / Error -->
    <div v-else class="empty">
      <div
        class="empty-ill"
        :class="{ 'empty-ill--danger': state === 'error' }"
      >
        <slot name="icon">
          <svg
            v-if="state === 'error'"
            width="34"
            height="34"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <svg
            v-else
            width="34"
            height="34"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <rect
              x="3"
              y="4"
              width="18"
              height="16"
              rx="2"
              stroke="currentColor"
              stroke-width="2"
            />
            <path
              d="M3 9h18"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </slot>
      </div>
      <h3>{{ title }}</h3>
      <p v-if="message">{{ message }}</p>
      <div v-if="$slots.actions" class="row" style="gap:var(--space-3)">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
// Estados visuais reutilizáveis: loading (skeleton), vazio e erro.
export default {
  name: "ClinicStateBox",
  props: {
    state: {
      type: String,
      default: "empty",
      validator: v => ["loading", "empty", "error"].includes(v)
    },
    title: { type: String, default: "" },
    message: { type: String, default: "" },
    rows: { type: Number, default: 5 }
  },
  methods: {
    skelWidth(n) {
      const widths = ["100%", "92%", "78%", "85%", "60%", "70%"];
      return widths[(n - 1) % widths.length];
    }
  }
};
</script>

<style lang="scss" scoped>
.clinic-state__skel {
  padding: var(--space-6);
}
</style>
